import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProfileService } from '../profile.service';
import { SearchResult } from 'src/app/search/models/searchresult.model';
import { ExtendedCompanyProfile } from '../models/extendedcompanyprofile.model';
import { DataService } from 'src/app/shared/data.service';
import { CompanyCreditInfo } from './companycredit/models/companycreditinfo.model';
import { CompanyCreditService } from './companycredit/companycredit.service';
import { UserService } from 'src/app/shared/user.service';
import { User } from 'src/app/shared/user.model';

declare var $: any;
@Component({
  selector: 'app-companyprofile',
  templateUrl: './companyprofile.component.html',
  styleUrls: ['./companyprofile.component.css']
})
export class CompanyProfileComponent implements OnInit, OnDestroy {
  company: SearchResult = new SearchResult('','','','','','','','','','','','','','','','','','',false, false, false, false, '','',0,'','','','','','');
  profile: ExtendedCompanyProfile = new ExtendedCompanyProfile();
  creditInfo: CompanyCreditInfo;
  companySubscription: Subscription;
  profileSubscription: Subscription;
  creditSubscription: Subscription;
  isLoading: boolean;
  constructor(private profileService: ProfileService, private dataService: DataService, private companyCreditService: CompanyCreditService,
    private userService: UserService) { }
  ngOnInit() {
    this.profileSubscription = this.profileService.currentCompanyProfileLoaded
    .subscribe(
      (result: ExtendedCompanyProfile) => {
        this.profile = result;
      }
    );
    this.creditSubscription = this.companyCreditService.currentCreditInfoChanged
    .subscribe(
    (creditInfo: CompanyCreditInfo) => {
      this.creditInfo = creditInfo;
    }
    )
    this.companySubscription = this.profileService.currentCompanyChanged
      .subscribe(
        (company: SearchResult) => {
          this.company = company;
          this.dataService.getCompanyExtendedProfile(company.Id);
          $('#companyModal').modal('show');
          setTimeout(() => {
            $('#companyprofileview [data-toggle="tooltip"]').tooltip('dispose');
            $('#companyprofileview [data-toggle="tooltip"]').tooltip({html:true});
          }, 500);
        }
      );
  }
  ngOnDestroy() {
    this.companySubscription.unsubscribe();
    this.profileSubscription.unsubscribe();
    this.creditSubscription.unsubscribe();
  }
  getCleanPhoneForLink() {
    return "1" + this.company.Phone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "")
  }

  getCleanTollFreeForLink() {
    return "1" + this.company.TollFree.replace("(", "").replace(")", "").replace("-", "").replace(" ", "")
  }
  showIndividual(index: number){
    //this.dataService.getIndividualProfile(this.profile.Roster[index].Id);
  }
  showCourtesyReport() {
    var url: string;
    this.dataService.getCreditReportUrl("UpicCourtesyReport", this.company.CoId).subscribe((response) => {
      url = response;
      window.open(url, '_blank');
    });
  }
}
